var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21213 3.78787C4.09497 3.90503 3.90503 3.90503 3.78787 3.78787L0.512132 0.512131C0.323142 0.323142 0.456993 0 0.724264 0L7.27574 0C7.54301 0 7.67686 0.323143 7.48787 0.512132L4.21213 3.78787Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownSm);
export default __webpack_public_path__ + "static/media/caret-down-sm.f66aa5163b1687d8dc547a6f8d2ce3d3.svg";
export { ForwardRef as ReactComponent };